export const CONTEST_WIZARD_TOTAL_STEPS = 14;

export const CONTEST_WIZARD_STEPS: { id: string; title: string; headline: string; subtitle: string }[] = [
    {
        id: 'submission_type',
        title: 'Submission Type',
        headline: 'Define Your Reach',
        subtitle: 'Choose how creators discover and interact with your campaign brand values.',
    },
    {
        id: 'identity',
        title: 'Campaign Identity',
        headline: 'Campaign Identity',
        subtitle: 'Set the visual and title that represent your campaign everywhere.',
    },
    {
        id: 'brief',
        title: 'Brief & Requirements',
        headline: 'Creative Brief',
        subtitle: 'Tell creators what to make and what rules they must follow.',
    },
    {
        id: 'discoverability',
        title: 'Discoverability',
        headline: 'Get Discovered',
        subtitle: 'Tags and genres help the right creators find your campaign.',
    },
    {
        id: 'rules',
        title: 'Submission Rules',
        headline: 'Entry Rules',
        subtitle: 'Control how many times creators can enter and late submissions.',
    },
    {
        id: 'categories',
        title: 'Category Builder',
        headline: 'Category Builder',
        subtitle: 'Define submission categories, fees, and prize tiers.',
    },
    {
        id: 'awards',
        title: 'Awards & Prizes',
        headline: 'Awards & Prizes',
        subtitle: 'Assign cash prizes by placement and submission tier.',
    },
    {
        id: 'timeline',
        title: 'Timeline & Phases',
        headline: 'Campaign Timeline',
        subtitle: 'Schedule phases from preparation through judging.',
    },
    {
        id: 'voting',
        title: 'Voting & Rating',
        headline: 'Audience & Voting',
        subtitle: 'Public voting and content rating guidelines.',
    },
    {
        id: 'technical',
        title: 'Technical Spec',
        headline: 'Technical Specifications',
        subtitle: 'Duration, format, and accepted media types.',
    },
    {
        id: 'judging',
        title: 'Judging & Files',
        headline: 'Judging Criteria',
        subtitle: 'How jurors score entries and optional PDF attachments.',
    },
    {
        id: 'references',
        title: 'References',
        headline: 'References & Playlist',
        subtitle: 'Optional reference videos and submission playlists.',
    },
    {
        id: 'review',
        title: 'Review',
        headline: 'Review & Submit',
        subtitle: 'Confirm your campaign details before funding the prize pool.',
    },
    {
        id: 'funding',
        title: 'Fund Prize Pool',
        headline: 'Fund Prize Pool',
        subtitle: 'Lock prize money from your campaign wallet, then publish.',
    },
];
